import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import HowItWorks from './components/HowItWorks';
import AboutUs from './components/AboutUs';
import Resources from './components/Resources';
import ContactUs from './components/ContactUs';
import BackendTest from './components/BackendTest';
import Modal from './components/Modal';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';

function App({ user, onSignOut, onShowAuth }) {
  const [currentPage, setCurrentPage] = useState('home');
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const handleNavigate = (page) => {
    setCurrentPage(page);
  };

  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} user={user} onShowAuth={onShowAuth} />;
      case 'how-it-works':
        return <HowItWorks onNavigate={handleNavigate} />;
      case 'about':
        return <AboutUs onNavigate={handleNavigate} onShowAuth={onShowAuth} />;
      case 'resources':
        return <Resources onNavigate={handleNavigate} onShowAuth={onShowAuth} />;
      case 'contact':
        return <ContactUs onNavigate={handleNavigate} />;
      case 'backend-test':
        return <BackendTest />;
      default:
        return <HomePage onNavigate={handleNavigate} user={user} onShowAuth={onShowAuth} />;
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#00162C] font-poppins">
      <Navigation 
        currentPage={currentPage} 
        onNavigate={handleNavigate} 
        user={user} 
        onSignOut={onSignOut}
        onShowAuth={onShowAuth}
      />
      
      <main>
        {renderCurrentPage()}
      </main>

      <footer className="bg-[#00162C] border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo and Description */}
            <div className="md:col-span-1">
              <h3 className="text-white text-2xl font-bold mb-4">RateIQ</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Lorem ipsum dolor sit amet consectetur adipiscing elit phasellus amet.
              </p>
            </div>

            {/* Pages Column */}
            <div>
              <h4 className="text-white font-semibold mb-4">Pages</h4>
              <div className="space-y-3">
                <button
                  onClick={() => handleNavigate('about')}
                  className="block text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  About Us
                </button>
                <button
                  onClick={() => handleNavigate('how-it-works')}
                  className="block text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  How it Works
                </button>
              </div>
            </div>

            {/* Resources Column */}
            <div>
              <h4 className="text-white font-semibold mb-4">Resources</h4>
              <div className="space-y-3">
                <button
                  onClick={() => handleNavigate('resources')}
                  className="block text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Resources
                </button>
                <button
                  onClick={onShowAuth}
                  className="block text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Upload Statement
                </button>
              </div>
            </div>

            {/* Account Column */}
            <div>
              <h4 className="text-white font-semibold mb-4">Account</h4>
              <div className="space-y-3">
                <button
                  onClick={onShowAuth}
                  className="block text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Client Login
                </button>
                <button
                  onClick={() => handleNavigate('contact')}
                  className="block text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Contact
                </button>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-gray-800 pt-6 mt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm">
                Copyright © 2025 RateIQ
              </p>
              <div className="flex space-x-6">
                <button
                  onClick={() => setShowPrivacy(true)}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Privacy Policy
                </button>
                <button
                  onClick={() => setShowTerms(true)}
                  className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                >
                  Terms of Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal 
        isOpen={showPrivacy} 
        onClose={() => setShowPrivacy(false)} 
        title="Privacy Policy"
      >
        <PrivacyPolicy />
      </Modal>
      <Modal 
        isOpen={showTerms} 
        onClose={() => setShowTerms(false)} 
        title="Terms of Service"
      >
        <TermsOfService />
      </Modal>
    </div>
  );
}

export default App; 